import React from 'react';
import './DetailsImgComp.css';
import {Grid,Button} from '@mui/material';
import { FaFilter } from 'react-icons/fa';
import Img1 from './../Assets/pic1.jpg'
import Img2 from './../Assets/pic2.jpg'
import Img3 from './../Assets/pic3.jpg'
import Img4 from './../Assets/pic4.jpg'
import Img5 from './../Assets/pic5.jpg'

const DetailsImgComp = () => {
  return (
    <div className='detailsImgCompMain'>
        <p style={{fontWeight:700,fontSize:22}}>Lily Beach Resort {'&'} Spa, Maldives, With Pool, AI</p>
        <div className='ImgCompSubDetails'>
        <p style={{fontWeight:700,textDecoration:'underline'}}>Maldives</p>
        <p> <FaFilter style={{marginRight:10}} /> Share <FaFilter style={{marginRight:10,marginLeft:40}} /> Save</p>
        </div>
        <Grid container>
            <Grid item md={6}>
            <img src={'https://images.unsplash.com/photo-1600240644455-3edc55c375fe?auto=format&fit=crop&w=400&h=250&q=60'} style={{borderTopLeftRadius:20,borderBottomLeftRadius:20}} width={'100%'} height={'350px'} />
            </Grid>

            <Grid item md={3} pl={'10px'}>
            <img src={'https://images.unsplash.com/photo-1653408400816-af6dba0c9432?auto=format&fit=crop&w=400&h=250&q=60'} width={'100%'} height={'175px'} style={{marginBottom:0,paddingBottom:'5px'}} />
            <img src={'https://images.unsplash.com/photo-1653312727964-736f11663ef6?auto=format&fit=crop&w=400&h=250&q=80'} width={'100%'} height={'175px'} style={{marginTop:-7,paddingTop:'5px'}} />

            </Grid>

            <Grid item md={3} pl={'10px'}>
            <img src={'https://images.unsplash.com/photo-1629447236132-22c57cd0f0bf?auto=format&fit=crop&w=400&h=250&q=60'} width={'100%'} height={'175px'} style={{marginBottom:0,borderTopRightRadius:20,paddingBottom:'5px'}} />
            <img src={'https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=400&h=250&q=60'} width={'100%'} height={'175px'} style={{marginTop:-7,borderBottomRightRadius:20,paddingTop:'5px'}} />
                
            </Grid>
        </Grid>
    </div>
  )
}

export default DetailsImgComp